export var MatcherName;
(function (MatcherName) {
    MatcherName[MatcherName["ProductAssignedException"] = 0] = "ProductAssignedException";
    MatcherName[MatcherName["DataValidationException"] = 1] = "DataValidationException";
    MatcherName[MatcherName["ValueExistsException"] = 2] = "ValueExistsException";
})(MatcherName || (MatcherName = {}));
const locallyHandledErrorMatchers = new Map();
export const registerLocallyHandledErrorMatcher = (name, errorMatcher) => {
    locallyHandledErrorMatchers.set(name, errorMatcher);
};
export const singleErrorMatcher = ({ message, operationName }) => {
    return (errorResponse) => {
        var _a;
        if (((_a = errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.graphQLErrors) === null || _a === void 0 ? void 0 : _a.length) !== 1) {
            return false;
        }
        if (message && errorResponse.graphQLErrors[0].message !== message) {
            return false;
        }
        if (operationName && operationName !== errorResponse.operation.operationName) {
            return false;
        }
        return true;
    };
};
export const isLocallyHandledError = (errorResponse) => {
    return Array.from(locallyHandledErrorMatchers.values()).some(matcher => matcher(errorResponse));
};
